import { render, staticRenderFns } from "./MonthPicker.vue?vue&type=template&id=5b3b5b20&scoped=true&"
import script from "./MonthPicker.vue?vue&type=script&lang=js&"
export * from "./MonthPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3b5b20",
  null
  
)

export default component.exports